import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { UsersPage } from '~/components/admin/users-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/users')({
  validateSearch: z.object({
    q: z.string().max(100).catch('').default(''),
    page: z.number().int().min(0).catch(0).default(0),
  }),
  head: () => ({ meta: [{ title: `${m.admin_nav_users()} – ${m.app_name()}` }] }),
  component: UsersRoute,
})

function UsersRoute() {
  const { q, page } = Route.useSearch()
  return (
    <>
      <PageHeader title={m.admin_nav_users()} />
      <UsersPage q={q} page={page} />
    </>
  )
}
